import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import RichText, { fragment } from '../RichText';
import OutsideClickHandler from '../../../utils/outsideClickHandler';

import {
  Dropdown,
  DropdownBtn,
  DropdownMenu,
  Dropdowns,
  NavLink,
  DropdownLink,
} from './styles';

const DropdownNavigationItem = ({
  id,
  heading,
  links,
  dropdowns,
  openDropdown,
  onNavItemTabbed,
  handleKeyDown,
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const isOpen = !!dropdowns.find(dropdownID => id === dropdownID);
    setIsActive(isOpen);
  }, [dropdowns, id]);

  return (
    <Dropdown key={id} isActive={isActive}>
      <DropdownBtn
        onClick={() => (isActive ? openDropdown([]) : openDropdown([id]))}
        onKeyDown={onNavItemTabbed}
        $isActive={isActive}
        aria-expanded={isActive}
        aria-controls={id}
      >
        {heading}
      </DropdownBtn>
      <DropdownMenu id={id} $isActive={isActive}>
        {links.map((link, index) => {
          const isFirstEl = index === 0;
          const isLastEl = links.length - 1 === index;
          const onKeyDown =
            isLastEl || isFirstEl ? e => handleKeyDown(e, isLastEl) : undefined;
          return (
            <DropdownLink
              key={link.id}
              className="nav-link"
              data={link}
              onKeyDown={onKeyDown}
            >
              <RichText document={link.label} options={fragment} />
            </DropdownLink>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

DropdownNavigationItem.propTypes = {
  id: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  dropdowns: PropTypes.arrayOf(PropTypes.string).isRequired,
  openDropdown: PropTypes.func.isRequired,
  onNavItemTabbed: PropTypes.func.isRequired,
  handleKeyDown: PropTypes.func.isRequired,
};

const NavigationTabs = ({ data }) => {
  const [dropdowns, setDropdowns] = useState([]);

  const handleKeyDown = (e, isLast) =>
    e.keyCode === 9 && (isLast ? !e.shiftKey : e.shiftKey) && setDropdowns([]);

  return (
    <OutsideClickHandler
      isActive={dropdowns.length >= 1}
      callback={() => setDropdowns([])}
    >
      <Dropdowns>
        {data &&
          data.map(tab =>
            tab.dropdownToggle ? (
              <DropdownNavigationItem
                key={tab.id}
                id={tab.id}
                heading={tab.navigationHeading}
                links={tab.ctas}
                dropdowns={dropdowns}
                openDropdown={setDropdowns}
                onNavItemTabbed={e => handleKeyDown(e, false)}
                handleKeyDown={handleKeyDown}
              />
            ) : (
              <Dropdown key={tab.id}>
                <NavLink className="nav-link" data={tab.ctas[0]}>
                  <RichText document={tab.ctas[0].label} />
                </NavLink>
              </Dropdown>
            ),
          )}
      </Dropdowns>
    </OutsideClickHandler>
  );
};

NavigationTabs.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default NavigationTabs;
